import { OperationItem } from "../utils"

export const getOperationItemIsTransferred = (
  operationItem: OperationItem,
  operationOwnerId: string | undefined,
  isReinforcedTraceability: boolean
) => {
  const contact = operationItem.operation?.contact
  return (
    (contact &&
      (contact.userId !== operationOwnerId || isReinforcedTraceability)) ||
    !operationItem.isInInformationRequest
  )
}
